export default class Notification {
	constructor(props) {
		this.header = props.header
		this.text = props.text
		this.title = props.title
		this.type = props.type
		this.actionTitle = props.actionTitle
		this.items = props.items
	}
}